var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.cat_id,on:{"click":function($event){return _vm.routerTo(item.cat_id)}}},[_c('img',{attrs:{"src":item.cat_pic,"loading":"lazy"}}),_c('p',[_vm._v(_vm._s(item.cat_name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }